// A aba de Exercícios de Fixação abre este modal pelo `data-permissions="elite"`,
// então ele precisa acompanhar o seletor em todas as telas que o renderizam.
import './index.scss';
import 'components/modals/not_elite_user_modal';

const TAB_SELECTOR = '.js-question-type-tab';

(function ($) {
  'use strict';

  // O bind é feito direto no elemento (e não delegado em `document`) porque o
  // handler global de `utils/permissions/permissions.js` também escuta o clique
  // e chama `stopImmediatePropagation()` ao bloquear usuários sem Elite. Um
  // handler delegado em `document` poderia ser cortado antes de rodar.
  $(TAB_SELECTOR).on('click', function () {
    window.UserTracker.emit('event', {
      eventName: 'question type tab clicked',
      data: {
        'tab type': $(this).data('tabType')
      }
    });
  });
})(jQuery);
